<template>
	<div class="index">
		<div class="index__notice">
			<p class="index__notice-text">업무 알림</p>
			<div class="index__notice-detail">
				<p class="index__detail">
					1. 금주의 자동푸시 문구 : 💄{{ month }}월
					{{ weekOfMonth }}주 업데이트 된 뷰티 랭킹을 확인하세요! 💄
					(링크종류 : 24, 링크코드 : 0)
				</p>
				<p
					v-for="(item, index) in filteredItems"
					:key="index"
					class="index__detail"
				>
					{{ item.order }}. {{ item.text }}
					<router-link :to="item.link" class="index__link">
						{{ item.label }}
					</router-link>
					{{ getPostposition(item.label) }}
					<span class="index__point">{{ item.count }}</span
					>건 있습니다.
				</p>
			</div>
		</div>
		<div class="index__contentWrapper">
			<div class="index__contet-">
				<UserDashboard
					:newUserMap="newUserMap"
					:newReviewMap="newReviewMap"
					:newReviewUserMap="newReviewUserMap"
				/>
				<StatusBoard :factorCount="factorCount" />
				<ul class="index__list">
					<li class="index__list-item">
						<router-link :to="`/manage/search-log`">
							<button class="index__btn">
								검색로그 TOP 10000
							</button>
						</router-link>
					</li>
					<li class="index__list-item">
						<router-link :to="`/register/register-block`">
							<button class="index__btn">회원 차단 이력</button>
						</router-link>
					</li>
					<li class="index__list-item">
						<router-link :to="`/register/register-report`">
							<button class="index__btn">회원 신고 이력</button>
						</router-link>
					</li>
				</ul>
			</div>
			<div class="index__request-list">
				<RequestDashboard
					v-for="(item, index) in requestItems"
					:key="index"
					:request="item"
				/>
			</div>
		</div>
		<div class="index__footer">
			<p>© Glowpick 2014 - {{ currentYear }}</p>
			<p>서울 서초구 법원로 4길 11-6, 3층</p>
			<p>☎ 070-7755-2976 / FAX 02-6455-2976</p>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import RequestDashboard from '../components/main/RequestDashboard.vue';
	import UserDashboard from '../components/main/UserDashboard.vue';
	import StatusBoard from '../components/main/StatusBoard.vue';

	export default {
		components: {
			RequestDashboard,
			UserDashboard,
			StatusBoard,
		},
		data() {
			return {
				weekOfMonth: 1,
				currentYear: new Date().getFullYear(),
				currentDate: new Date(),
				month: new Date().getMonth() + 1,
				productAddReqNum: 0,
				productFixReqNum: 0,
				factorRegReqNum: 0,
				reportCnt: 0,
				qnaReportCnt: 0,
				qnaReplyReportCnt: 0,
				factorCount: null,
				productAddReqData: [],
				productFixReqData: [],
				factorRegReqData: [],
				newUserMap: {},
				newReviewMap: {},
				newReviewUserMap: {},
				aiInspectionCount: 0,
			};
		},

		computed: {
			noticeItems() {
				return [
					{
						order: 1,
						text: '확인되지 않은',
						label: '제품등록요청',
						link: '/product/req-list?code=CSP_01',
						count: this.productAddReqNum,
					},
					{
						order: 2,
						text: '확인되지 않은',
						label: '제품수정요청',
						link: '/product/req-list?code=CSP_02',
						count: this.productFixReqNum,
					},
					{
						order: 3,
						text: '확인되지 않은',
						label: '성분등록요청',
						link: '/product/req-list?code=CSP_03',
						count: this.factorRegReqNum,
					},
					{
						order: 4,
						text: '확인되지 않은',
						label: '리뷰신고접수',
						link: '/review/report/list',
						count: this.reportCnt,
					},
					{
						order: 5,
						text: '확인되지 않은',
						label: 'Q&A 질문 신고',
						link: '/qna/q/report/list',
						count: this.qnaReportCnt,
					},
					{
						order: 6,
						text: '확인되지 않은',
						label: 'Q&A 답변 신고',
						link: '/qna/a/report/list',
						count: this.qnaReplyReportCnt,
					},
					{
						order: 7,
						text: '확인되지 않은',
						label: 'Q&A 댓글 신고',
						link: '/qna/c/report/list',
						count: this.qnaChildReplyReportCnt,
					},
					{
						order: 8,
						text: '확인되지 않은',
						label: '리뷰검수(AI)',
						link: '/review/ai/inspection',
						count: this.aiInspectionCount,
					},
				];
			},
			requestItems() {
				return [
					{
						title: '제품 등록 요청',
						count: this.productAddReqNum,
						moreLink: '/product/req-list?code=CSP_01',
						data: this.productAddReqData,
						productLink: '/product/req/CSP_01',
					},
					{
						title: '제품 수정 요청',
						count: this.productFixReqNum,
						moreLink: '/product/req-list?code=CSP_02',
						data: this.productFixReqData,
						productLink: '/product/req/CSP_02',
					},
					{
						title: '성분 등록 요청',
						count: this.factorRegReqNum,
						moreLink: '/product/req-list?code=CSP_03',
						data: this.factorRegReqData,
						productLink: '/product/req/CSP_03',
					},
				];
			},
			filteredItems() {
				return this.noticeItems
					.filter(item => item.count > 0)
					.map((item, index) => ({ ...item, order: index + 2 }));
			},
		},

		created() {
			this.initData();
			this.calculateDateInfo();
		},

		methods: {
			calculateDateInfo() {
				const now = moment();
				this.month = now.month() + 1;
				this.weekOfMonth = Math.ceil(now.date() / 7);
			},
			async initData() {
				try {
					const [commonRes, inspectionRes] = await Promise.all([
						this.$axiosAdmin2.get('/api/common/cs'),
						this.$axiosAdmin2.get(
							'/api/review-inspection/not-completed-count'
						),
					]);

					const {
						productAddReq,
						productFixReq,
						factorRegReq,
						reportCnt,
						qnaReportCnt,
						qnaReplyReportCnt,
						qnaChildReplyReportCnt,
						factorCount,
						newUserMap,
						newReviewMap,
						newReviewUserMap,
					} = commonRes.data;

					this.aiInspectionCount =
						inspectionRes.data.reviewInspectionNotCompletedCount;

					this.productAddReqNum = productAddReq.total;
					this.productFixReqNum = productFixReq.total;
					this.factorRegReqNum = factorRegReq.total;

					this.productAddReqData = productAddReq.data;
					this.productFixReqData = productFixReq.data;
					this.factorRegReqData = factorRegReq.data;

					this.reportCnt = reportCnt;
					this.qnaReportCnt = qnaReportCnt;
					this.qnaReplyReportCnt = qnaReplyReportCnt;
					this.qnaChildReplyReportCnt = qnaChildReplyReportCnt;
					this.factorCount = factorCount;
					this.newUserMap = newUserMap;
					this.newReviewMap = newReviewMap;
					this.newReviewUserMap = newReviewUserMap;
				} catch (err) {
					console.error(err);
					alert(
						'메인페이지 데이터를 불러오는 데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			getPostposition(text) {
				const lastChar = text[text.length - 1];
				const lastCharCode = lastChar.charCodeAt(0);
				if ((lastCharCode - 0xac00) % 28 > 0) {
					return '이';
				} else {
					return '가';
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.index {
		&__list {
			display: flex;
			gap: 10px;
			margin-top: 50px;
			padding: 0;
			list-style: none;
		}

		&__list-item {
			button {
				display: flex;
				align-items: center;
				justify-content: center;
				width: auto;
				min-width: 99px;
				height: 38px;
				line-height: 36px;
				border-radius: 4px;
				padding: 12px;
				font-size: 1rem;
				margin: 0 4px;
				background-color: #4a5571;
				color: #fff;
				border-color: #4a5571;

				&:hover {
					background-color: #30374a;
					border-color: #30374a;
					color: #fff;
				}
			}
			font-size: 15px;
			color: #333;
			cursor: pointer;
		}

		&__link {
			color: #007bff;
			text-decoration: none;
			cursor: pointer;
		}

		&__notice {
			background-color: #f5f5f5;
			padding: 20px;
			border-radius: 5px;
			margin-bottom: 20px;
			border: 1px solid #e9e9e9;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			gap: 100px;
		}
		&__detail {
			margin-bottom: 9px;
		}
		&__point {
			display: inline;
			padding: 5px;
			margin-bottom: 10px;
			font-weight: bold;
			color: #fff;
			border-radius: 30%;
			background-color: rgb(255, 68, 68);
		}
		&__notice-text {
			font-size: 28px;
			color: #333;
			font-weight: bold;
		}
		&__notice-detail {
			font-size: 14px;
		}
		&__request-list {
			flex: 1 0;
			display: flex;
			flex-direction: column;
		}
		&__contentWrapper {
			display: flex;
			gap: 20px;
		}
		&__footer {
			margin-top: 20px;
			text-align: center;
			padding: 20px;
			font-size: 14px;
			color: #666;
		}
	}
</style>
